const GA_MEASUREMENT_ID = import.meta.env.VITE_GA_MEASUREMENT_ID;

// Declaração para o TypeScript entender que `gtag` existe no objeto window
declare global {
  interface Window {
    gtag: (...args: unknown[]) => void;
  }
}

/**
 * Envia um evento de pageview para o Google Analytics.
 * @param url - A URL da página a ser rastreada.
 */
export const pageview = (url: string) => {
  if (window.gtag && GA_MEASUREMENT_ID) {
    window.gtag("config", GA_MEASUREMENT_ID, {
      page_path: url,
    });
  }
};

/**
 * Envia um evento customizado para o Google Analytics.
 * @param action - O nome da ação do evento (ex: 'purchase').
 * @param params - Parâmetros adicionais para o evento.
 */
export const event = ({ action, params }: { action: string; params?: Record<string, unknown> }) => {
  if (window.gtag) {
    window.gtag("event", action, params);
  }
};